import { TextField } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { change } from '../../../store/actions/account.action'

const Ezzy = (props) => {
    const dispatch = useDispatch();
    const { account, error } = useSelector(state => state.accountReducer)

    return (
        <>
            <div className="mb-3">
                <label className="label-custom bs-color-b">Client ID</label>
                <TextField
                    error={(error.ezzy_client_id) && true}
                    value={account.ezzy_client_id || ''}
                    onChange={e => {
                        dispatch(change({ezzy_client_id: e.target.value}))
                        if (error.ezzy_client_id && delete error.ezzy_client_id);
                    }}
                />

                {(error.ezzy_client_id) &&
                    <strong className="text-danger">{error.ezzy_client_id[0]}</strong>
                }
            </div>

            <div className="mb-3">
                <label className="label-custom bs-color-b">Client Secret</label>
                <TextField
                    disabled={(props.id)}
                    error={(error.ezzy_client_secret) && true}
                    value={account.ezzy_client_secret || ''}
                    onChange={e => {
                        dispatch(change({ezzy_client_secret: e.target.value}))
                        if (error.ezzy_client_secret && delete error.ezzy_client_secret);
                    }}
                />

                {(error.ezzy_client_secret) &&
                    <strong className="text-danger">{error.ezzy_client_secret[0]}</strong>
                }
            </div>
        </>
    )
}


export default Ezzy